module.exports = __webpack_public_path__ + "img/9788968333149.c42f1214.jpg";